import ExcelJS from 'exceljs'
import { DownLoadData } from './types'

export type FormatTypes = 'excel' | 'csv' | 'tsv'

type downloadProps = {
  data: DownLoadData | undefined
  format: FormatTypes
  fileName?: string
  sheetName?: string
}
export const downloadData = async ({
  data,
  format,
  fileName,
  sheetName
}: downloadProps) => {
  if (data === undefined) return false
  try {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(sheetName ?? 'sheet1')
    worksheet.views.push({
      state: 'frozen',
      ySplit: 1
    })
    worksheet.columns = data.header.map(h => ({
      header: h.title,
      key: h.key,
      style: {
        alignment: {
          vertical: 'top'
        }
      }
    }))
    data.body.forEach(record => {
      const row = worksheet.addRow(record)
      if (format === 'excel') {
        data.header.forEach((column, col) => {
          if (!column.key) return
          const value = record[column.key]
          const cell = row.getCell(col + 1)
          if (typeof value === 'number') {
            cell.style['numFmt'] = `#,##0${column.unit ?? ''}`
          } else if (typeof value === 'string') {
            if (value.includes('\n')) {
              cell.style['alignment'] = {
                ...cell.style['alignment'],
                wrapText: true
              }
            }
          }
        })
      }
    })
    const { uint8Array, downloadName } = (
      format === 'csv' ? {
        uint8Array: await workbook.csv.writeBuffer(),
        downloadName: `${fileName ?? 'download'}.csv`
      } :
      format === 'tsv' ? {
        uint8Array: await workbook.csv.writeBuffer({
          formatterOptions: {
            delimiter: '\t',
            quote: false,
          }
        }),
        downloadName: `${fileName ?? 'download'}.tsv`
      } : {
        uint8Array: await workbook.xlsx.writeBuffer(),
        downloadName: `${fileName ?? 'download'}.xlsx`
      }
    )
    const blob = new Blob([uint8Array], { type: 'application/octet-binary' })
    const link = document.createElement('a')
    link.setAttribute('href', window.URL.createObjectURL(blob))
    link.setAttribute('download', downloadName)
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return true
  } catch (e) {
    console.error(`failed to build sheet data.`, e)
    return false
  }
}

const TAB = '\t'
const NEWLINE = '\n'

const adjustCellText = (
  text: string | number | null | undefined
): string => {
  if (text === null || text === undefined) return ''
  if (typeof text === 'number') return `${text}`
  return text
}
const csvRow = <T>(
  columns: T[],
  cell: (column: T) => string | number | null | undefined
) => {
  return columns.map((column) => adjustCellText(cell(column))).join(TAB)
}
export const clipCsvData = async (data: DownLoadData | undefined) => {
  if (data === undefined) return false

  const columns = data.header

  const rows: string[] = []
  rows.push(csvRow(columns, column => column.title))
  rows.push(...data.body.map(row => csvRow(columns, column => {
    const cell = row[column.key ?? '']
    if (typeof cell === 'string') {
      if (cell.indexOf('\n')) return `"${cell}"`
    }
    return cell
  })))
  await navigator.clipboard.writeText(rows.join(NEWLINE))
  return true
}
